<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/150kW/150kW.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">150kW三合一电驱总成</div>
                <div class="detail-banner-desc transmission">
                    兼容差速锁、半轴断开装置的三合一电驱动总成
                    <div class="detail-desc">
                        <div>
                            高度集成：可兼容差速锁、半轴断开功能；<br />
                        </div>
                        <div>
                            轻量化，高扭重比；<br />
                        </div>
                        <div>
                            NVH性能优异：低谐波绕组结构；<br />
                        </div>
                        <div>
                            高效率：发卡式扁线绕组，高槽满率，高效率轴承，少油量，总成最高效率94%。
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/150kW/150kW-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">150kW</div>
                                    <div class="k">电机峰值功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">16500rpm</div>
                                    <div class="k">电机峰值转速</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">3356N·m</div>
                                    <div class="k">峰值输出扭矩</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1</div>
                                    <div class="k">挡位数量</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">487*457*371</div>
                                    <div class="k">尺寸 X*Y*Z（mm）</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">79kg</div>
                                    <div class="k">重量</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '150kW三合一电驱总成 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'transmission/150.html'
};

import { createApp } from 'vue';
import App from './150.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./150.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
